import { generateUniqueId } from '@/helpers/uuidUtils';
import { entityTypes } from '@/enums/generic';
import { Compatibility } from '@/models/Compatibility';
import { Type } from 'class-transformer';
import 'reflect-metadata';

export class ProductEstimation {
  id?: string;
  type: string;
  customizedNumber: string;
  count: number;
  estimation?: number;

  constructor(params: {
    id?: string;
    type: string;
    customizedNumber: string;
    count: number;
    estimation?: number;
  }) {
    this.id = params?.id ?? generateUniqueId();
    this.type = params?.type;
    this.customizedNumber = params?.customizedNumber;
    this.count = params?.count;
    this.estimation = params?.estimation;
  }
}

export class InspectedBuilding {
  public id: string;
  public buildingId?: string;
  public note: string;
  public type: string;
  public productEstimations: ProductEstimation[];
  @Type(() => Compatibility)
  public compatibility?: Compatibility;

  constructor() {
    this.id = generateUniqueId();
    this.buildingId = undefined;
    this.note = '';
    this.type = entityTypes.inspectedBuilding;
    this.productEstimations = [];
    this.compatibility = new Compatibility();
  }

  getParentId() {
    return this.buildingId;
  }
}
